<template>
    <span>
        <vSelect
            placeholder="Couleur"
            :options="[
                    { value: 'primary', label: 'Bleu' },
                    { value: 'secondary', label: 'Gris' },
                    { value: 'success', label: 'Vert' },
                    { value: 'danger', label: 'Rouge' },
                    { value: 'warning', label: 'Jaune' },
                    { value: 'info', label: 'Bleu clair' },
                    { value: 'light', label: 'Blanc' },
                    { value: 'dark', label: 'Noir' },
                ]"
            v-model="alertClass"
            :reduce="option => option.value">
            <div slot="no-options">Aucune commande ne correspond à votre recherche</div>
            <template #option="{ label, value }">
                <div :class="'m-0 p-1 text-center alert alert-'+value">{{ label }}</div>
            </template>
        </vSelect>
        <input type="hidden" id="alert_class" name="alert_class" :value="alertClass">
    </span>
</template>
<script>
    import vSelect from 'vue-select';

    export default {
        name: 'AlertColorSelector',

        components: {
            vSelect,
        },

        props: {
            value: {
                type: String,
                required: false,
            },
        },

        data() {
            return {
                alertClass: this.value,
            };
        },

        computed: {},

        methods: {},
    }
</script>

<style lang="scss">
</style>
